import { useEffect, useState } from "react";
import { useAuthenticatedRequest } from "./request";
import { validationHierachyData } from "./utils/material-data";

export interface ApplicatonsItem {
  application: string;
  grade: any[];
}

export interface HierachyItem {
  class: string;
  application: ApplicatonsItem[];
}

export interface Hierachy {
  industry: string;
  description?: string;
  applicationClass: HierachyItem[];
}

const HIERARCHY_URL = "/v0/hierarchy";

/**
 * Custom hook to fetch and validate hierarchy data
 * @param isExternalView - Flag to determine which hierarchy endpoint to use
 * @returns Validated hierarchy data
 */
export const useHierarchyData = (isExternalView: boolean) => {
  const [data, setData] = useState<Hierachy[]>([]);
  const url = isExternalView
    ? `${HIERARCHY_URL}?isExternalView=true`
    : HIERARCHY_URL;
  const [result] = useAuthenticatedRequest<Hierachy[]>(url);

  useEffect(() => {
    const hierarchyData = validationHierachyData(result);
    setData(hierarchyData);
  }, [result]);

  return data;
};
